import { createFileRoute } from "@tanstack/react-router";
import { PillarPage, buildPillarHead } from "@/components/site/PillarPage";
import { PILLAR_BY_SLUG } from "@/lib/pillars";

const pillar = PILLAR_BY_SLUG["sales-leads-referrals"];

const faqs = [
  {
    q: "Does KCN give me leads, or do I have to generate my own?",
    a: "Both. KCN feeds qualified leads from multiple internal and external sources, and trains every agent to build their own database and referral engine. Agents who run the playbook get more of both over time.",
  },
  {
    q: "Where do KCN leads actually come from?",
    a: "A mix: Brivity IDX, KWKLY codes, ISA leverage from the Location Department, Facebook ad leads, and a strong external/internal referral network across our markets.",
  },
  {
    q: "Are referrals split or assigned?",
    a: "Referral economics depend on source and role - KCN uses clear, documented referral agreements so there's never ambiguity about who owns what. We'll walk through the specifics on a Strategy Call.",
  },
  {
    q: "Can I refer business across KCN markets?",
    a: "Yes - and that's one of the underrated upsides of being in a national network. Active KCN agents send and receive referrals across markets, with clear agreements and an admin team that helps coordinate.",
  },
];

export const Route = createFileRoute("/sales-leads-and-referrals")({
  head: () => buildPillarHead(pillar, faqs),
  component: () => (
    <PillarPage
      pillar={pillar}
      intro="Most teams either over-promise leads or pretend they don't matter. KCN does neither. We give agents access to vetted lead sources and a national referral network - and we coach the conversion process so leads turn into closings."
      sections={[
        {
          eyebrow: "Where leads come from",
          heading: "A diversified lead engine.",
          bullets: [
            "Brivity IDX - agent-branded property search and lead capture",
            "KWKLY Codes - sign-rider text leads",
            "ISA Leverage - Location Department inside sales support",
            "Facebook Ad Leads - paid social campaigns",
            "External & Internal Referrals - KCN's national network",
          ],
        },
        {
          eyebrow: "Conversion, not just acquisition",
          heading: "Leads are step one. We coach step two.",
          body: "Every KCN lead source is paired with scripts, follow-up cadences, and accountability inside the CRM. Agents who run the playbook convert at materially higher rates - because the system, not the agent, is doing the remembering.",
        },
        {
          eyebrow: "The referral network",
          heading: "A national team that sends business back and forth.",
          body: "KCN's footprint across markets means agents send and receive referrals constantly - to relocation clients, to second-home buyers, to family members in other states. It's a real flywheel, not a brochure promise.",
        },
      ]}
      benefits={{
        heading: "What sales support at KCN looks like.",
        items: [
          "Brivity IDX with built-in lead capture",
          "ISA support for follow-up at scale",
          "Vetted paid-lead sources",
          "National internal referral network",
          "Scripts and SOPs for every source",
          "Database and sphere outreach systems",
        ],
      }}
      faqs={faqs}
    />
  ),
});
